<template>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('ajoutEditContrat.contrepartie.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-12">
            <b-field :label="$t('ajoutEditContrat.contrepartie.contrepartie')" v-if="!isDetail">
              <b-input v-model="contrat.contrepartie" type="textarea" rows="4">
              </b-input>
            </b-field>
            <b-field :label="$t('detailContrat.contrepartie')" v-else
                    custom-class="has-text-default is-italic has-text-weight-light mgb-0">

              <span class="has-text-link has-text-weight-bold is-prewrap">{{contrat.contrepartie}}
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BauxContrepartie',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
